import { ChangeEvent, useCallback, useEffect, useState } from 'react'
import { Label } from 'types/label'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'index'
import { getBreadLabels } from 'reducks/bread/selectors'
import fetchBreadLabels from 'reducks/bread/operations/fetchBreadLabels'
import { BreadLabel, BreadType } from 'types/bread'

type UseHandleBreadLabels = {
  breadLabels: BreadLabel[]
  handleBreadLabels: (event: ChangeEvent<HTMLInputElement>) => void
}

const useHandleBreadLabels = (bread: BreadType, labels: Label[]): UseHandleBreadLabels => {
  const dispatch = useDispatch()
  const prevBreadLabels = useSelector((state: State) => getBreadLabels(state))
  const [breadLabels, setBreadLabels] = useState<BreadLabel[]>([])

  const handleBreadLabels = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const id = event.target.id
      setBreadLabels((prevState) => {
        if (prevState.some((breadLabel) => breadLabel.label_ref.id === id)) {
          return [...prevState.filter((breadLabel) => breadLabel.label_ref.id !== id)]
        } else {
          const label = labels.find((label) => label.ref?.id === id)
          if (!label || !label.ref) return prevState
          return [...prevState, { label_ref: label.ref }]
        }
      })
    },
    [labels]
  )

  useEffect(() => {
    if (prevBreadLabels.length === 0) return
    setBreadLabels([...prevBreadLabels])
  }, [prevBreadLabels])

  // 既存の値をデータベースから取得
  useEffect(() => {
    if (!bread?.bread_ref || prevBreadLabels.length > 0) return
    dispatch(fetchBreadLabels(bread.bread_ref))
  }, [bread])

  return {
    breadLabels,
    handleBreadLabels,
  }
}

export default useHandleBreadLabels
